// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"61dec259","403":"e5478772","484":"e6f25ce4","551":"ae68630f","974":"8542e095"}[chunkId] + ".chunk.js";
};